/**
 * @description 请求配置
 */
import { getLocalStorage } from '@/utils/localStorage';
export default function getRequestCommonConfig() {
  return {
    headers: getLocalStorage('ticket')
      ? {
          Accept: 'application/json',
          ticket: getLocalStorage('ticket'),
        }
      : {
          Accept: 'application/json',
        },
    timeout: 30000,
    withCredentials: true,
    needEncrypt: true,
  };
}
